<template>
  <div id="app">
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    document.head.appendChild(meta)
  }
}
</script>

<style>
:root {
  /* 基础布局尺寸 */
  --header-height: 44px;
  --tabbar-height: 50px;
  --max-content-width: 768px;
  
  /* 容器间距 */
  --container-padding: 2vw;
  --container-gap: 2vw;
  --container-padding-small: 1vw;
  --container-gap-small: 1vw;
  --container-padding-large: 1.5vw;
  --container-gap-large: 1.5vw;
  
  /* 响应式断点 */
  --breakpoint-small: 320px;
  --breakpoint-medium: 375px;
  --breakpoint-large: 768px;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

.main-content {
  flex: 1;
  width: 100%;
  max-width: var(--max-content-width);
  margin: 0 auto;
  position: relative;
}
</style> 